// Layout spacing constants
export const GUTTER_SIZE = 15; // Spacing between cells in pixels
export const CELL_MIN_SIZE = 50; // Minimum cell dimension in pixels
export const CELL_INSET = 12; // Inset padding for cell overlays

// Resize handle dimensions
export const EDGE_HANDLE_SIZE = 8;
export const CORNER_HANDLE_SIZE = 16;
export const HANDLE_OFFSET = 4;

// Colors - Newsprint / CMYK palette
export const COLORS = {
  // CMYK primaries
  cyan: '#00a4e4',
  magenta: '#e4007c',
  yellow: '#ffe600',
  key: '#1a1a1a',

  // Borders
  border: '#888',
  borderLight: '#d6d0c4',
  borderMedium: '#b8b2a6',

  // Backgrounds (warm newsprint tones)
  background: '#f5f0e8',
  backgroundLight: '#faf7f2',
  backgroundWhite: '#fdfcf9',

  // Text
  textPrimary: '#1a1a1a',
  textSecondary: '#333',
  textMuted: '#666',

  // Selection & focus
  selectionOutline: '#b8b2a6',
  hoverShadow: 'rgba(0, 0, 0, 0.15)',

  // Destructive actions
  destructive: '#b42318',
  destructiveBorder: 'rgba(180, 35, 24, 0.45)',

  // Tip card
  tipCardBackground: '#e8f4fa',
  tipCardBorder: 'rgba(0, 164, 228, 0.35)',
  tipCardShadow: 'rgba(0, 0, 0, 0.1)',
  tipCardText: '#1a1a1a',
};

// Z-index layers
export const Z_INDEX = {
  edgeHandle: 10,
  cornerHandle: 11,
  bubbleHandle: 14,
  tipCard: 10,
  adSlot: 6,
  menuBar: 50,
};

// Typography
export const FONT_SIZES = {
  small: 12,
  medium: 14,
  large: 16,
};

// Spacing
export const SPACING = {
  xs: 4,
  sm: 6,
  md: 8,
  lg: 10,
  xl: 12,
  xxl: 16,
};

// Border radius
export const BORDER_RADIUS = {
  sm: 4,
  md: 6,
  lg: 8,
};
